/**
 * Three steps on the Landing page.
 */

import { Box, Heading, Stack, Text } from "@chakra-ui/react";
import React from "react";

const ThreeSteps = React.memo(() => {
  return (
    <Box
      w="100vw"
      // minHeight="50vh"
      pt={10}
      pb={20}
      px={[4, 4, 20, 32]}
      bgColor="teal.50"
    >
      <Heading
        as="h3"
        mb={[10, 14, 24]}
        color="teal.900"
        fontWeight="700"
        maxWidth={{ base: "initial", "3xl": "80%" }}
        margin={{ "2xl": "auto" }}
      >
        3 simple steps
      </Heading>
      <Stack
        flexDir={["column", "row"]}
        alignItems="flex-start"
        justifyContent="space-between"
        gap={[7, 10, 12]}
        flexWrap="wrap"
        maxWidth={{ base: "initial", "3xl": "80%" }}
        margin="auto"
        ml={[4, 8, 10, "auto"]}
      >
        <Box maxWidth={{ base: "100%", lg: "320px" }}>
          <Text
            color="blackAlpha.300"
            fontWeight="700"
            fontSize={[64, 80, 116]}
          >
            01
          </Text>
          <Text
            ml={[30, 35, 16]}
            mt={[-10, -16, -20]}
            color="teal.900"
            fontWeight="700"
            fontSize={20}
            // className="-mt-20"
          >
            Start the Personality Survey to get your predicted fit in select
            sectors based on your survey responses.
          </Text>
        </Box>
        <Box maxWidth={{ base: "100%", lg: "320px" }}>
          <Text
            color="blackAlpha.300"
            fontWeight="700"
            fontSize={[64, 80, 116]}
          >
            02
          </Text>
          <Text
            ml={[30, 35, 16]}
            mt={[-10, -16, -20]}
            color="teal.900"
            fontWeight="700"
            fontSize={20}
            className="-mt-20"
          >
            Our algorithms will ascertain your predicted fit in open jobs near
            you.
          </Text>
        </Box>
        <Box maxWidth={{ base: "100%", lg: "320px" }}>
          <Text
            color="blackAlpha.300"
            fontWeight="700"
            fontSize={[64, 80, 116]}
          >
            03
          </Text>
          <Text
            ml={[30, 35, 16]}
            mt={[-10, -16, -20]}
            color="teal.900"
            fontWeight="700"
            fontSize={20}
          >
            Apply to the jobs the algorithm suggests for you, and{" "}
            <span
              // fontSize={["initial", "1.5rem", "2rem"]}
              className="initial md:text-display-sm"
            >
              GET PAID!
            </span>
          </Text>
        </Box>
      </Stack>
    </Box>
  );
});

ThreeSteps.displayName = "ThreeSteps";

export default ThreeSteps;
